import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-avatar-profile',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="profile-container">{{letterName | uppercase}}</div>
`,
  styles: `
  .profile-container{
    width: 34px;
    background-color:#AABBCC;
    height: 34px;
    color: #fdfdfd;
    border-radius: 50%;
    text-align: center;
    align-content: center;
    font-size:12px;
}
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarProfileComponent implements OnChanges {

  // @Input() profileName: any;
  @Input() firstName = '';
  @Input() lastName = '';
  letterName = '';

  ngOnChanges() {
    this.filterOutName();
  }

  filterOutName() {
    const firstLetter = this.firstName ? this.firstName.charAt(0) : '';
    const lastLetter = this.lastName ? this.lastName.charAt(0) : '';
    this.letterName = firstLetter + lastLetter;
  }
  
}
